import { render } from "./ReturnPortalSelectItemsToReturn.vue?vue&type=template&id=3315fcb2"
import script from "./ReturnPortalSelectItemsToReturn.vue?vue&type=script&lang=js"
export * from "./ReturnPortalSelectItemsToReturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__